"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UISelectableButton = _interopRequireDefault(require("UIComponents/button/UISelectableButton"));

var _SuccessModal = _interopRequireDefault(require("./SuccessModal"));

var LANG_ROUTE = 'upgrades.activationModal.new';

var AcademyTrialModal = function AcademyTrialModal(_ref) {
  var onSuccess = _ref.onSuccess;
  return _react.default.createElement(_SuccessModal.default, {
    header: _react.default.createElement(_FormattedMessage.default, {
      message: LANG_ROUTE + ".successModal.header"
    }),
    footer: _react.default.createElement("div", {
      className: "text-left m-top-6",
      style: {
        width: '100%'
      }
    }, _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
      message: LANG_ROUTE + ".successModal.academyHeader"
    })), _react.default.createElement(_UIList.default, null, _react.default.createElement(_UISelectableButton.default, {
      className: "m-bottom-2 display-inline-block text-left",
      textLabel: _react.default.createElement(_FormattedMessage.default, {
        message: LANG_ROUTE + ".successModal.actions.exploreTrial"
      }),
      block: true,
      truncatable: false,
      onClick: function onClick() {
        window.location = "/trial-guide/" + _PortalIdParser.default.get() + "/marketing-pro";
      }
    }), _react.default.createElement(_UISelectableButton.default, {
      className: "m-bottom-2 display-inline-block text-left",
      textLabel: _react.default.createElement(_FormattedMessage.default, {
        message: LANG_ROUTE + ".successModal.actions.finishCourse"
      }),
      block: true,
      truncatable: false,
      onClick: onSuccess
    })))
  });
};

var _default = AcademyTrialModal;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/components/AcademyTrialModal.js
// module id = 744
// module chunks = 5 6